import { ReactElement } from 'react'
import { IconProps } from '../icons'

const Eye = ({
  height = '25',
  width = '21',
  hardcodedColor = '#FFFFFF',
  color,
  className = '',
  strokeWidth = '1.5',
  ...props
}: IconProps): ReactElement => {
  const colorClass = color ? `${`fill-${color}`}` : ''
  const fill = hardcodedColor && !color ? hardcodedColor : 'currentColor'

  return (
    <svg
      width={width}
      height={height}
      className={`${colorClass} ${className}`}
      viewBox="0 0 25 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="eye-optic--health-medical-eye-optic" fill="none">
        <path
          id="Vector 2095"
          d="M12.5006 3.95129C4.96333 3.95129 1.79883 11.9527 1.79883 12.0911C1.79883 12.2295 4.96333 20.2309 12.5006 20.2309C20.0378 20.2309 23.2024 12.2295 23.2024 12.0911C23.2024 11.9527 20.0378 3.95129 12.5006 3.95129Z"
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector 2096"
          d="M4.18224 8.12675L0.998779 5.04102"
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector 2097"
          d="M9.18264 4.5067L8.00049 0.769043"
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector 2099"
          d="M20.8672 8.18211L24.0013 5.04102"
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector 2100"
          d="M15.8276 4.50672L17.0028 0.769043"
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Ellipse 902"
          d="M9.37317 12.0913C9.36757 12.9088 9.69162 13.6928 10.274 14.2708C10.8564 14.8489 11.6495 15.1736 12.4787 15.1736C13.308 15.1736 14.1055 14.8489 14.6958 14.2708C15.2861 13.6928 15.6209 12.9088 15.6265 12.0913C15.6321 11.2738 15.308 10.4898 14.7256 9.91171C14.1432 9.33366 13.3502 9.00891 12.5209 9.00891C11.6917 9.00891 10.8942 9.33366 10.3039 9.91171C9.71356 10.4898 9.37877 11.2738 9.37317 12.0913Z"
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default Eye
